<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="dedication">
<p class="dedicationText">Dedicated to the memory of Don G. Rickey,<br/> who knew these men.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// IndianWarVeterans_dedication.vue?4de0e833